// Meta Pixel Event Helper
// Use this to track events throughout the application

export const trackMetaEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params);
    console.log(`Meta Pixel Event: ${eventName}`, params);
  }
};

export const trackViewContent = (contentName, contentType = 'product') => {
  trackMetaEvent('ViewContent', {
    content_name: contentName,
    content_type: contentType
  });
};

export const trackLead = (source) => {
  trackMetaEvent('Lead', {
    content_name: source
  });
};

export const trackInitiateCheckout = (product, value, currency = 'INR') => {
  trackMetaEvent('InitiateCheckout', {
    content_name: product,
    value: value,
    currency: currency
  });
};

export const trackPurchase = (value, currency = 'INR', contents = []) => {
  trackMetaEvent('Purchase', {
    value: value,
    currency: currency,
    contents: contents
  });
};
